<template>
  <ButtonText
    v-if="showForEntityTypes.includes(clickedEntityType)"
    :buttonText="title"
    :iconLeft="iconEditSmall"
    class="edit-button"
    size="small"
    @onClicked="onClick"
  ></ButtonText>
</template>
<script lang="ts" setup>
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import { useGeneralStore } from '@/pinia'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import iconEditSmall from '@/design-system/assets/icons/Icon-Edit-Small.svg'

defineProps<{
  showForEntityTypes: string[]
  title: string
}>()
const piniaStore = useGeneralStore()
const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)

function onClick() {
  piniaStore.setCurrentOverlayModalPinia('editRoomPinia')
  piniaStore.setShowOverlayModalPinia(true)
}
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';
.edit-button {
  color: variables.$color-primary;
  @include font-mixins.desktop-bold-label;
}
</style>
